import { useEffect, useMemo, useState } from 'react';

import { CHECK_STATUS_INTERVAL, STATUS_REQUEST_PATH } from 'src/constants';
import type { StatusApiResponse } from './types';
import { IncidentStatus } from './types';

export const useOngoingIncidentsCheck = (): boolean => {
  const [hasOngoingIncidents, setHasOngoingIncidents] = useState<boolean>(false);

  useEffect(() => {
    const load = async () => {
      const res = await fetch(STATUS_REQUEST_PATH, {
        credentials: 'omit',
      });

      const data: StatusApiResponse = await res.json();

      setHasOngoingIncidents(
        data.incidents.some((incident) => [IncidentStatus.identified, IncidentStatus.investigating].includes(incident.status)),
      );
    };

    load();

    const pointer = setInterval(load, CHECK_STATUS_INTERVAL);

    return () => clearInterval(pointer);
  }, []);

  return useMemo(() => hasOngoingIncidents, [hasOngoingIncidents]);
};
